import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const ChatCommerceContainer = styled.div`
  padding-top: 96px;
  padding-bottom: 96px;

  &.bg-sprite {
    .eyebrow {
      border: 2px solid ${color.oxfordBlue[600]} !important;
      color: ${color.oxfordBlue[600]} !important;
    }
  }
  &.bg-plum {
    .heading {
      color: ${color.common.white} !important;
    }
  }
  .heading-container {
    .eyebrow {
      font-size: 14px;
      font-weight: 500;
      border: 2px solid ${color.secondary[600]};
      border-radius: 40px;
      padding: 7px 15px 3px;
      line-height: 1em;
      display: inline-block;
      margin-bottom: 24px;
      color: ${color.secondary[600]};
      @media (max-width: 576px) {
        font-size: 12px;
        line-height: 18px;
      }
    }
    .heading {
      font-weight: 900;
      font-size: 48px;
      line-height: 60px;
      text-align: center;
      letter-spacing: -0.02em;
      color: ${color.oxfordBlue[900]};
      @media (max-width: 992px) {
        font-size: 36px;
        line-height: 44px;
      }
      @media (max-width: 576px) {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }
  .description {
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 28px;
      color: ${color.copy[700]};
      @media (max-width: 992px) {
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        color: ${color.copy[700]};
      }
    }
    h3 {
      font-weight: 900;
      font-size: 24px;
      line-height: 32px;
      color: ${color.oxfordBlue[900]};
      @media (max-width: 992px) {
        font-weight: 850;
        font-size: 20px;
        line-height: 30px;
      }
      @media (max-width: 576px) {
        font-size: 16px;
        line-height: 24px;
      }
    }
    ul {
      list-style: none;
      padding-left: 0;
      font-weight: 500;
      font-size: 18px;
    }
    a {
      color: ${color.common.linkBlue};
      transition: all 450ms ease-in-out;
      text-decoration: none;
      position: relative;
      width: max-content;
      padding-right: 15px;
      font-weight: 700;
      &:before,
      &:after {
        border-right: 2px solid;
        content: "";
        display: block;
        height: 8px;
        margin-top: -6px;
        position: absolute;
        transform: rotate(135deg);
        right: 0px;
        top: 57%;
        width: 0;
      }
      :after {
        margin-top: -1px;
        transform: rotate(45deg);
      }
    }
  }

  .content-row {
    @media (max-width: 992px) {
      flex-direction: column-reverse;
    }
  }
`
export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1170px;
  @media (max-width: 992px) {
    max-width: 770px;
  }
  @media (max-width: 576px) {
    max-width: 506px;
  }
  @media (max-width: 499px) {
    padding-left: 30px;
    padding-right: 30px;
  }
`
